/**
 * @ngdoc service
 * @name app.weatherService
 * @description
 * # weatherService
 * Service to talk with backend api.
 * @requires app.apiService#wrap
 * @requires constants:config
 **/

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

// TODO move to config
const WEATHER_ICON_PREFIX_URL = 'http://images.itv.weather.news12.com/weather/images/612_36H_';

/*---------------------------------------------------------*\
 * weatherService
\*---------------------------------------------------------*/
/* @ngInject */
function weatherService(apiService, config) {
  /**
   * @ngdoc
   * @name app.weatherService#getWeatherIconsUrl
   * @methodOf app.weatherService
   * @example
   * ``` js
   * weatherService.getWeatherIconsUrl('WC');
   * ```
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of three characters.
   * @description
   * Service to form url for weather icons.
   * @returns {string} String url referencing an image file (.png format), this url
   * will include a timestamp query.
   **/
  this.getWeatherIconsUrl = (region) => {
    const timestamp = new Date().getTime();
    if (region === 'BK' || region === 'BX') {
      region = 'NYC';
    } else if (region === 'WC') {
      region = 'HV';
    }
    return WEATHER_ICON_PREFIX_URL + region + '.png?timestamp=' + timestamp;
  };

  /**
   * @ngdoc
   * @name app.weatherService#getWeatherForecast
   * @methodOf app.weatherService
   * @example
   * weatherService.getWeatherForecast(region)
   * @param {string} region selected region abbreviation, case 'Bronx' => 'BX',
   * 'New Jersey' => 'NJ', max of three characters.
   * @description
   * Service to call apiService to get string url for weatherForecast livestream;
   * @returns {htmlPromise} promise to resolve to string url referencing a livestream video,
   * or Will throw an error if region code is not a string or is the incorrect length.
   **/
  this.getWeatherForecast = (region) => {
    if (angular.isString(region) && region.length < 3) {
      return apiService.wrap(config.relBaseUrlAPi + '/forecastvideo/' + region, {}, 'forecast').then((data) => {
        if (data && data.data) {
          return data.data;
        }
        return false;
      });
    }
    return new Error('Invalid Region Code');
  };
}

weatherService.$inject = ['apiService', 'config'];

const api = angular
  .module('weatherService', ['apiService'])
  .service('weatherService', weatherService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/weather.js
 **/